let controlRutasExport = {
	boleta:'calculadora-botonera',
	reporte: 'Reportes',
	usuarios: 'GestionUsuarios'
};

let fallbackRoutesExport = {
	principal: 'calculadora-botonera',
};

// rutas en caso de que el usuario quiera acceder a una ruta en la que 
// el no tiene acceso.
// tambien funcionan como redireccionamiento de pantalla principal
fallbackRoutesExport[ controlRutasExport.reporte ] = fallbackRoutesExport.principal;
fallbackRoutesExport[ controlRutasExport.usuarios ] = fallbackRoutesExport.principal;


export let controlRutas = controlRutasExport;
export let fallbackRoutes = fallbackRoutesExport;